import { render } from "./ChatsManualContent.vue?vue&type=template&id=5356e25e&ts=true"
import script from "./ChatsManualContent.vue?vue&type=script&lang=ts"
export * from "./ChatsManualContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__